import { Select } from '@iqueue/ui-kit'
import { useCallback, useRef } from 'react'
import SensorPresenter from '../../api/sensorPresenter'
import { t } from '../../hooks/useTranslate'

export default function PickSensorSerialNumber({ name = 'sensorSerialNumber', current, value, onChange, ...props }) {
  const cache = useRef()

  const render = useCallback((sensorSerialNumber) => {
    const item = cache.current?.indexed[sensorSerialNumber]

    return {
      id: sensorSerialNumber,
      title: sensorSerialNumber,
      subtitle: item?.devEUI,
    }
  }, [t, current])

  const fetchData = useCallback(() => {
    return SensorPresenter.readIndexed(cache, 'serialNumber')
  }, [])

  return <Select
    allowSearch
    name={ name }
    entries={ fetchData }
    render={ render }
    value={ value }
    { ...props }
  />
}
